<router-outlet />

<p-toast />
<p-confirmDialog />
<app-gip-confirm />
